import { VehicleDetailsGroupOutput } from './vehicle-details-group-output.model';


export class SelectByVehicleGroupIdOutputData implements ISelectByVehicleGroupIdOutputData {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id!: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name!: string;
    vehicle_details_group!: VehicleDetailsGroupOutput[];

    constructor(data?: ISelectByVehicleGroupIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_group_id = _data["vehicle_group_id"];
            this.vehicle_group_name = _data["vehicle_group_name"];
            if (Array.isArray(_data["vehicle_details_group"])) {
                this.vehicle_details_group = [] as any;
                for (let item of _data["vehicle_details_group"])
                    this.vehicle_details_group!.push(VehicleDetailsGroupOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectByVehicleGroupIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new SelectByVehicleGroupIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_group_id"] = this.vehicle_group_id;
        data["vehicle_group_name"] = this.vehicle_group_name;
        if (Array.isArray(this.vehicle_details_group)) {
            data["vehicle_details_group"] = [];
            for (let item of this.vehicle_details_group)
                data["vehicle_details_group"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelectByVehicleGroupIdOutputData {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name: string;
    vehicle_details_group: VehicleDetailsGroupOutput[];
}

